<template lang="html">
    <div class="default-page-paddings">
        <div class="container container-medium article">
            <Heading :title="$t('new_account_pc')" v-if="!inModal" :routeName="'confidentiality'" :alignment="'text-left'"></Heading>
            <div class="default-content reading">
				<template v-if="locale == 'ro'">
					<p>&nbsp;Uniunea Națională a Transportatorilor Rutieri din Rom&acirc;nia (UNTRR) prelucrează datele dumneavoastră cu caracter personal, prin mijloace automatizate, scopul fiind evidența persoanelor delegate și/sau &icirc;mputernicite ale firmelor membre UNTRR, emiterea rovinietelor, facturarea și &icirc;nregistrarea plății pentru produsele și serviciile furnizate de UNTRR conform comenzii dumneavoastră și informarea ulterioară a dumneavoastră de la distanță privind serviciul prestat, c&acirc;nd e cazul.</p>
					<p>&nbsp;Nu sunteți obligat(ă) să furnizați datele, acestea fiind necesare &icirc;ndeplinirii comenzii dvs., refuzul dvs. determină imposibilitatea de a realiza serviciul solicitat.</p>
					<p>&nbsp;Datele cu caracter personal vor fi procesate doar &icirc;n urma acordului primit de la dumneavoastră.</p>
					<p>&nbsp;Informațiile &icirc;nregistrate sunt destinate utilizării de către operator și sunt comunicate numai următorilor terți:&nbsp; Compania Națională de Autostrăzi și Drumuri Naționale din Rom&acirc;nia, pentru emiterea&nbsp; rovinietei, furnizorului de servicii de trimitere SMS (pentru trimiterea seriei rovinietei prin SMS, &icirc;n cazul comenzilor &icirc;nregistrate pe site-ul www.e-rovinieta.ro), procesatorului de plăți &nbsp;online cu cardul bancar (&icirc;n cazul plăților online cu cardul bancar). Datele personale necesare efectuării plăților online cu cardul vor fi transferate securizat către procesatorul de plăți.</p>
					<p><strong>Conform REGULAMENTULUI (UE) 2016/679 AL PARLAMENTULUI EUROPEAN ȘI AL CONSILIULUI din 27 aprilie 2016</strong> privind protecția persoanelor fizice &icirc;n ceea ce privește prelucrarea datelor cu caracter personal și privind libera circulație a acestor date și de abrogare a Directivei 95/46/CE (Regulamentul general privind protecția datelor):</p>
					<p>&nbsp;<strong>Art. 13: Informaţii care se furnizează &icirc;n cazul &icirc;n care datele cu caracter personal sunt colectate de la persoana vizată </strong></p>
					<p>(1) &Icirc;n cazul &icirc;n care datele cu caracter personal referitoare la o persoană vizată sunt colectate de la aceasta, operatorul, &icirc;n momentul obţinerii acestor date cu caracter personal, furnizează persoanei vizate toate informaţiile următoare:</p>
					<ol>
						<li>a) identitatea şi datele de contact ale operatorului şi, după caz, ale reprezentantului acestuia;</li>
						<li>b) datele de contact ale responsabilului cu protecţia datelor, după caz;</li>
						<li>c) scopurile &icirc;n care sunt prelucrate datele cu caracter personal, precum şi temeiul juridic al prelucrării;</li>
						<li>d) &icirc;n cazul &icirc;n care prelucrarea se face &icirc;n temeiul articolului 6 alineatul (1) litera (f), interesele legitime urmărite de operator sau de o parte terţă;</li>
						<li>e) destinatarii sau categoriile de destinatari ai datelor cu caracter personal;</li>
						<li>f) dacă este cazul, intenţia operatorului de a transfera date cu caracter personal către o ţară terţă sau o organizaţie internaţională şi existenţa sau absenţa unei decizii a Comisiei privind caracterul adecvat sau, &icirc;n cazul transferurilor menţionate la articolul 46 sau 47 sau la articolul 49 alineatul (1) al doilea paragraf, o trimitere la garanţiile adecvate sau corespunzătoare şi la mijloacele de a obţine o copie a acestora, &icirc;n cazul &icirc;n care acestea au fost puse la dispoziţie.</li>
					</ol>
					<p>(2) &Icirc;n plus faţă de informaţiile menţionate la alineatul (1), &icirc;n momentul &icirc;n care datele cu caracter personal sunt obţinute, operatorul furnizează persoanei vizate următoarele informaţii suplimentare necesare pentru a asigura o prelucrare echitabilă şi transparentă:</p>
					<ol>
						<li>a) perioada pentru care vor fi stocate datele cu caracter personal sau, dacă acest lucru nu este posibil, criteriile utilizate pentru a stabili această perioadă;</li>
						<li>b) existenţa dreptului de a solicita operatorului, &icirc;n ceea ce priveşte datele cu caracter personal referitoare la persoana vizată, accesul la acestea, rectificarea sau ştergerea acestora sau restricţionarea prelucrării sau a dreptului de a se opune prelucrării, precum şi a dreptului la portabilitatea datelor;</li>
						<li>c) atunci c&acirc;nd prelucrarea se bazează pe articolul 6 alineatul (1) litera (a) sau pe articolul 9 alineatul (2) litera (a), existenţa dreptului de a retrage consimţăm&acirc;ntul &icirc;n orice moment, fără a afecta legalitatea prelucrării efectuate pe baza consimţăm&acirc;ntului &icirc;nainte de retragerea acestuia;</li>
						<li>d) dreptul de a depune o pl&acirc;ngere &icirc;n faţa unei autorităţi de supraveghere;</li>
						<li>e) dacă furnizarea de date cu caracter personal reprezintă o obligaţie legală sau contractuală sau o obligaţie necesară pentru &icirc;ncheierea unui contract, precum şi dacă persoana vizată este obligată să furnizeze aceste date cu caracter personal şi care sunt eventualele consecinţe ale nerespectării acestei obligaţii;</li>
						<li>f) existenţa unui proces decizional automatizat incluz&acirc;nd crearea de profiluri, menţionat la articolul 22 alineatele (1) şi (4), precum şi, cel puţin &icirc;n cazurile respective, informaţii pertinente privind logica utilizată şi privind importanţa şi consecinţele preconizate ale unei astfel de prelucrări pentru persoana vizată.</li>
					</ol>
					<p>(3) &Icirc;n cazul &icirc;n care operatorul intenţionează să prelucreze ulterior datele cu caracter personal &icirc;ntr-un alt scop dec&acirc;t cel pentru care acestea au fost colectate, operatorul furnizează persoanei vizate, &icirc;nainte de această prelucrare ulterioară, informaţii privind scopul secundar respectiv şi orice informaţii suplimentare relevante, &icirc;n conformitate cu alineatul (2).</p>
					<p>(4) Alineatele (1), (2) şi (3) nu se aplică dacă şi &icirc;n măsura &icirc;n care persoana vizată deţine deja informaţiile respective.</p>
					<table class="table table-bordered">
						<tbody>
							<tr>
								<td width="150">
									<p><strong>Date personale</strong></p>
								</td>
								<td width="420">
									<p><strong>Motiv</strong></p>
								</td>
								<td width="*">
									<p><strong>Perioada stocării conform prevederilor legale</strong></p>
								</td>
							</tr>
							<tr>
								<td>
									Nume și prenume
								</td>
								<td>
									<p>Emitere factură</p>
								</td>
								<td>
									<p>10 ani</p>
								</td>
							</tr>
							<tr>
								<td>
									<p>Adresă</p>
								</td>
								<td>
									<p>Emitere factură conform codului fiscal art. 319 aliniatul 20</p>
								</td>
								<td>
									<p>10 ani</p>
								</td>
							</tr>
							<tr>
								<td>
									<p>&nbsp;</p>
									<p>Telefon</p>
								</td>
								<td>
									<p>Notificare emitere rovinietă (opțional)</p>
									<p>Contact in cazul in care datele sunt greșite sau comanda a eșuat</p>
								</td>
								<td >
									<p>3 ani</p>
								</td>
							</tr>
							<tr>
								<td>
									<p>&nbsp;</p>
									<p>E-mail</p>
								</td>
								<td>
									<p>Confirmare creare cont</p>
									<p>Trimitere factura rovinietă</p>
                  <p>Trimitere e-mail cu valabilitatea rovinietei conform solicitării clientului</p>
									<p>Notificare ștergere cont</p>
								</td>
								<td>
									<p>3 ani</p>
								</td>
							</tr>
							<tr>
								<td>
									<p>Date masina</p>
								</td>
								<td>
									<p>Emitere de rovinietă</p>
								</td>
								<td>
									<p>10 ani</p>
								</td>
							</tr>
							<tr>
								<td>
									<p>&nbsp;</p>
									<p>IP Address</p>
								</td>
								<td>
									<p>Logurile aplicatiei Web (această informație ne este necesară &icirc;n caz de atac DDoS) sau analiză anonimă de trafic</p>
								</td>
								<td>
									<p>30 de zile</p>
								</td>
							</tr>
						</tbody>
					</table>
					<p>&nbsp;</p>
					<p><strong>Art. 14: Informaţii care se furnizează &icirc;n cazul &icirc;n care datele cu caracter personal nu au fost obţinute de la persoana vizată </strong></p>
					<p>(1) &Icirc;n cazul &icirc;n care datele cu caracter personal nu au fost obţinute de la persoana vizată, operatorul furnizează persoanei vizate următoarele informaţii:</p>
					<ol>
						<li>a) identitatea şi datele de contact ale operatorului şi, după caz, ale reprezentantului acestuia;</li>
						<li>b) datele de contact ale responsabilului cu protecţia datelor, după caz;</li>
						<li>c) scopurile &icirc;n care sunt prelucrate datele cu caracter personal, precum şi temeiul juridic al prelucrării;</li>
						<li>d) categoriile de date cu caracter personal vizate;</li>
						<li>e) destinatarii sau categoriile de destinatari ai datelor cu caracter personal, după caz;</li>
						<li>f) dacă este cazul, intenţia operatorului de a transfera date cu caracter personal către un destinatar dintr-o ţară terţă sau o organizaţie internaţională şi existenţa sau absenţa unei decizii a Comisiei privind caracterul adecvat sau, &icirc;n cazul transferurilor menţionate la articolul 46 sau 47 sau la articolul 49 alineatul (1) al doilea paragraf, o trimitere la garanţiile adecvate sau corespunzătoare şi la mijloacele de a obţine o copie a acestora, &icirc;n cazul &icirc;n care acestea au fost puse la dispoziţie.</li>
					</ol>
					<p>(2) Pe l&acirc;ngă informaţiile menţionate la alineatul (1), operatorul furnizează persoanei vizate următoarele informaţii necesare pentru a asigura o prelucrare echitabilă şi transparentă &icirc;n ceea ce priveşte persoana vizată:</p>
					<ol>
						<li>a) perioada pentru care vor fi stocate datele cu caracter personal sau, dacă acest lucru nu este posibil, criteriile utilizate pentru a stabili această perioadă;</li>
						<li>b) &icirc;n cazul &icirc;n care prelucrarea se face &icirc;n temeiul articolului 6 alineatul (1) litera (f), interesele legitime urmărite de operator sau de o parte terţă;</li>
						<li>c) existenţa dreptului de a solicita operatorului, &icirc;n ceea ce priveşte datele cu caracter personal referitoare la persoana vizată, accesul la acestea, rectificarea sau ştergerea acestora sau restricţionarea prelucrării şi a dreptului de a se opune prelucrării, precum şi a dreptului la portabilitatea datelor;</li>
						<li>d) atunci c&acirc;nd prelucrarea se bazează pe articolul 6 alineatul (1) litera (a) sau pe articolul 9 alineatul (2) litera (a), existenţa dreptului de a retrage consimţăm&acirc;ntul &icirc;n orice moment, fără a afecta legalitatea prelucrării efectuate pe baza consimţăm&acirc;ntului &icirc;nainte de retragerea acestuia;</li>
						<li>e) dreptul de a depune o pl&acirc;ngere &icirc;n faţa unei autorităţi de supraveghere;</li>
						<li>f) sursa din care provin datele cu caracter personal şi, dacă este cazul, dacă acestea provin din surse disponibile public;</li>
						<li>g) existenţa unui proces decizional automatizat incluz&acirc;nd crearea de profiluri, menţionat la articolul 22 alineatele (1) şi (4), precum şi, cel puţin &icirc;n cazurile respective, informaţii pertinente privind logica utilizată şi privind importanţa şi consecinţele preconizate ale unei astfel de prelucrări pentru persoana vizată.</li>
					</ol>
					<p>(3) Operatorul furnizează informaţiile menţionate la alineatele (1) şi (2):</p>
					<ol>
						<li>a) &icirc;ntr-un termen rezonabil după obţinerea datelor cu caracter personal, dar nu mai mare de o lună, ţin&acirc;ndu-se seama de circumstanţele specifice &icirc;n care sunt prelucrate datele cu caracter personal;</li>
						<li>b) dacă datele cu caracter personal urmează să fie utilizate pentru comunicarea cu persoana vizată, cel t&acirc;rziu &icirc;n momentul primei comunicări către persoana vizată respectivă; sau</li>
						<li>c) dacă se intenţionează divulgarea datelor cu caracter personal către un alt destinatar, cel mai t&acirc;rziu la data la care acestea sunt divulgate pentru prima oară.</li>
					</ol>
					<p>(4) &Icirc;n cazul &icirc;n care operatorul intenţionează să prelucreze ulterior datele cu caracter personal &icirc;ntr-un alt scop dec&acirc;t cel pentru care acestea au fost obţinute, operatorul furnizează persoanei vizate, &icirc;nainte de această prelucrare ulterioară, informaţii privind scopul secundar respectiv şi orice informaţii suplimentare relevante, &icirc;n conformitate cu alineatul (2).</p>
					<p>(5) Alineatele (1)-(4) nu se aplică dacă şi &icirc;n măsura &icirc;n care:</p>
					<ol>
						<li>a) persoana vizată deţine deja informaţiile;</li>
						<li>b) furnizarea acestor informaţii se dovedeşte a fi imposibilă sau ar implica eforturi disproporţionate, &icirc;n special &icirc;n cazul prelucrării &icirc;n scopuri de arhivare &icirc;n interes public, &icirc;n scopuri de cercetare ştiinţifică sau istorică ori &icirc;n scopuri statistice, sub rezerva condiţiilor şi a garanţiilor prevăzute la articolul 89 alineatul (1), sau &icirc;n măsura &icirc;n care obligaţia menţionată la alineatul (1) din prezentul articol este susceptibil să facă imposibilă sau să afecteze &icirc;n mod grav realizarea obiectivelor prelucrării respective In astfel de cazuri, operatorul ia măsuri adecvate pentru a proteja drepturile, libertăţile şi interesele legitime ale persoanei vizate, inclusiv punerea informaţiilor la dispoziţia publicului;</li>
						<li>c) obţinerea sau divulgarea datelor este prevăzută &icirc;n mod expres de dreptul Uniunii sau de dreptul intern sub incidenţa căruia intră operatorul şi care prevede măsuri adecvate pentru a proteja interesele legitime ale persoanei vizate; sau</li>
						<li>d) &icirc;n cazul &icirc;n care datele cu caracter personal trebuie să răm&acirc;nă confidenţiale &icirc;n temeiul unei obligaţii statutare de secret profesional reglementate de dreptul Uniunii sau de dreptul intern, inclusiv al unei obligaţii legale de a păstra secretul.</li>
					</ol>
					<p><strong>Art. 15: Dreptul de acces al persoanei vizate </strong></p>
					<p>(1) Persoana vizată are dreptul de a obţine din partea operatorului o confirmare că se prelucrează sau nu date cu caracter personal care o privesc şi, &icirc;n caz afirmativ, acces la datele respective şi la următoarele informaţii:</p>
					<ol>
						<li>a) scopurile prelucrării;</li>
						<li>b) categoriile de date cu caracter personal vizate;</li>
						<li>c) destinatarii sau categoriile de destinatari cărora datele cu caracter personal le-au fost sau urmează să le fie divulgate, &icirc;n special destinatari din ţări terţe sau organizaţii internaţionale;</li>
						<li>d) acolo unde este posibil, perioada pentru care se preconizează că vor fi stocate datele cu caracter personal sau, dacă acest lucru nu este posibil, criteriile utilizate pentru a stabili această perioadă;</li>
						<li>e) existenţa dreptului de a solicita operatorului rectificarea sau ştergerea datelor cu caracter personal ori restricţionarea prelucrării datelor cu caracter personal referitoare la persoana vizată sau a dreptului de a se opune prelucrării;</li>
						<li>f) dreptul de a depune o pl&acirc;ngere &icirc;n faţa unei autorităţi de supraveghere;</li>
						<li>g) &icirc;n cazul &icirc;n care datele cu caracter personal nu sunt colectate de la persoana vizată, orice informaţii disponibile privind sursa acestora;</li>
						<li>h) existenţa unui proces decizional automatizat incluz&acirc;nd crearea de profiluri, menţionat la articolul 22 alineatele (1) şi (4), precum şi, cel puţin &icirc;n cazurile respective, informaţii pertinente privind logica utilizată şi privind importanţa şi consecinţele preconizate ale unei astfel de prelucrări pentru persoana vizată.</li>
					</ol>
					<p>(2) &Icirc;n cazul &icirc;n care datele cu caracter personal sunt transferate către o ţară terţă sau o organizaţie internaţională, persoana vizată are dreptul să fie informată cu privire la garanţiile adecvate &icirc;n temeiul articolului 46 referitoare la transfer.</p>
					<p>(3) Operatorul furnizează o copie a datelor cu caracter personal care fac obiectul prelucrării. Pentru orice alte copii solicitate de persoana vizată, operatorul poate percepe o taxă rezonabilă, bazată pe costurile administrative. &Icirc;n cazul &icirc;n care persoana vizată introduce cererea &icirc;n format electronic şi cu excepţia cazului &icirc;n care persoana vizată solicită un alt format, informaţiile sunt furnizate &icirc;ntr-un format electronic utilizat &icirc;n mod curent.</p>
					<p>(4) Dreptul de a obţine o copie menţionată la alineatul (3) nu aduce atingere drepturilor şi libertăţilor altora.</p>
					<p><strong>Rectificare şi ştergere </strong></p>
					<p><strong>Art. 16: Dreptul la rectificare </strong></p>
					<p>Persoana vizată are dreptul de a obţine de la operator, fără &icirc;nt&acirc;rzieri nejustificate, rectificarea datelor cu caracter personal inexacte care o privesc. Ţin&acirc;ndu-se seama de scopurile &icirc;n care au fost prelucrate datele, persoana vizată are dreptul de a obţine completarea datelor cu caracter personal care sunt incomplete, inclusiv prin furnizarea unei declaraţii suplimentare.</p>
					<p><strong>Art. 17: Dreptul la ştergerea datelor ("dreptul de a fi uitat") </strong></p>
					<p>(1) Persoana vizată are dreptul de a obţine din partea operatorului ştergerea datelor cu caracter personal care o privesc, fără &icirc;nt&acirc;rzieri nejustificate, iar operatorul are obligaţia de a şterge datele cu caracter personal fără &icirc;nt&acirc;rzieri nejustificate &icirc;n cazul &icirc;n care se aplică unul dintre următoarele motive:</p>
					<ol>
						<li>a) datele cu caracter personal nu mai sunt necesare pentru &icirc;ndeplinirea scopurilor pentru care au fost colectate sau prelucrate;</li>
						<li>b) persoana vizată &icirc;şi retrage consimţăm&acirc;ntul pe baza căruia are loc prelucrarea, &icirc;n conformitate cu articolul 6 alineatul (1) litera (a) sau cu articolul 9 alineatul (2) litera (a), şi nu există niciun alt temei juridic pentru prelucrarea;</li>
						<li>c) persoana vizată se opune prelucrării &icirc;n temeiul articolului 21 alineatul (1) şi nu există motive legitime care să prevaleze &icirc;n ceea ce priveşte prelucrarea sau persoana vizată se opune prelucrării &icirc;n temeiul articolului 21 alineatul (2);</li>
						<li>d) datele cu caracter personal au fost prelucrate ilegal;</li>
						<li>e) datele cu caracter personal trebuie şterse pentru respectarea unei obligaţii legale care revine operatorului &icirc;n temeiul dreptului Uniunii sau al dreptului intern sub incidenţa căruia se află operatorul;</li>
						<li>f) datele cu caracter personal au fost colectate &icirc;n legătură cu oferirea de servicii ale societăţii informaţionale menţionate la articolul 8 alineatul (1).</li>
					</ol>
					<p>Contul va fi șters in maxim 30 de zile de la solicitarea primită din partea clientului.</p>
					<p>(2) &Icirc;n cazul &icirc;n care operatorul a făcut publice datele cu caracter personal şi este obligat, &icirc;n temeiul alineatului (1), să le şteargă, operatorul, ţin&acirc;nd seama de tehnologia disponibilă şi de costul implementării, ia măsuri rezonabile, inclusiv măsuri tehnice, pentru a informa operatorii care prelucrează datele cu caracter personal că persoana vizată a solicitat ştergerea de către aceşti operatori a oricăror linkuri către datele respective sau a oricăror copii sau reproduceri ale acestor date cu caracter personal.</p>
					<p>(3) Alineatele (1) şi (2a) nu se aplică &icirc;n măsura &icirc;n care prelucrarea este necesară:</p>
					<ol>
						<li>a) pentru exercitarea dreptului la liberă exprimare şi la informare;</li>
						<li>b) pentru respectarea unei obligaţii legale care prevede prelucrarea &icirc;n temeiul dreptului Uniunii sau al dreptului intern care se aplică operatorului sau pentru &icirc;ndeplinirea unei sarcini executate &icirc;n interes public sau &icirc;n cadrul exercitării unei autorităţi oficiale cu care este &icirc;nvestit operatorul;</li>
						<li>c) din motive de interes public &icirc;n domeniul sănătăţii publice, &icirc;n conformitate cu articolul 9 alineatul (2) literele (h) şi (i) şi cu articolul 9 alineatul (3);</li>
						<li>d) &icirc;n scopuri de arhivare &icirc;n interes public, &icirc;n scopuri de cercetare ştiinţifică sau istorică ori &icirc;n scopuri statistice, &icirc;n conformitate cu articolul 89 alineatul (1), &icirc;n măsura &icirc;n care dreptul menţionat la alineatul (1) este susceptibil să facă imposibilă sau să afecteze &icirc;n mod grav realizarea obiectivelor prelucrării respective; sau</li>
						<li>e) pentru constatarea, exercitarea sau apărarea unui drept &icirc;n instanţă.</li>
					</ol>
					<p><strong>Art. 18: Dreptul la restricţionarea prelucrării </strong></p>
					<p>(1) Persoana vizată are dreptul de a obţine din partea operatorului restricţionarea prelucrării &icirc;n cazul &icirc;n care se aplică unul din următoarele cazuri:</p>
					<ol>
						<li>a) persoana vizată contestă exactitatea datelor, pentru o perioadă care &icirc;i permite operatorului să verifice exactitatea datelor;</li>
						<li>b) prelucrarea este ilegală, iar persoana vizată se opune ştergerii datelor cu caracter personal, solicit&acirc;nd &icirc;n schimb restricţionarea utilizării lor;</li>
						<li>c) operatorul nu mai are nevoie de datele cu caracter personal &icirc;n scopul prelucrării, dar persoana vizată i le solicită pentru constatarea, exercitarea sau apărarea unui drept &icirc;n instanţă; sau</li>
						<li>d) persoana vizată s-a opus prelucrării &icirc;n conformitate cu articolul 21 alineatul (1), pentru intervalul de timp &icirc;n care se verifică dacă drepturile legitime ale operatorului prevalează asupra celor ale persoanei vizate.</li>
					</ol>
					<p>(2) &Icirc;n cazul &icirc;n care prelucrarea a fost restricţionată &icirc;n temeiul alineatului (1), astfel de date cu caracter personal pot, cu excepţia stocării, să fie prelucrate numai cu consimţăm&acirc;ntul persoanei vizate sau pentru constatarea, exercitarea sau apărarea unui drept &icirc;n instanţă sau pentru protecţia drepturilor unei alte persoane fizice sau juridice sau din motive de interes public important al Uniunii sau al unui stat membru.</p>
					<p>(3) O persoană vizată care a obţinut restricţionarea prelucrării &icirc;n temeiul alineatului (1) este informată de către operator &icirc;nainte de ridicarea restricţiei de prelucrare.</p>
					<p>&nbsp;</p>
					<p>Pentru exercitarea acestor drepturi, vă puteţi adresa cu o cerere scrisă, datată şi semnată la registratura UNTRR din Bucuresti, str. Ienachita Vacarescu nr. 60, sector 4, cod postal 040157 sau prin telefon la numarul 0720999216 sau prin e-mail la <a class="custom-link" href="mailto:protectiadatelor@untrr.ro">protectiadatelor@untrr.ro</a> . De asemenea, vă este recunoscut dreptul de a vă adresa justiţiei.</p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
				</template>

				<template v-else>
					<div>
						<p>
							<span>Uniunea Națională a Transportatorilor Rutieri din Rom&acirc;nia (UNTRR) processes your personal data by automated means, the purpose being the record of the delegated and/or authorized persons of UNTRR member companies, issuing vignette invoicing and registration of payment for products and services provided by UNTRR according your order and your subsequent remote information on the service provided, where applicable.</span>
						</p>
						<p>
							<span>You are not obliged to provide the data, as they are necessary for the fulfilment of your order, your refusal makes it impossible to perform the requested service.</span>
						</p>
						<p>
							<span>Personal data will only be processed following the agreement received from you.</span>
						</p>
						<p>
							<span>The registered information is intended for use by the operator and is communicated only to the following third parties: Romanian National Highways and National Roads Company, for issuing the toll, to the SMS sending service provider (for sending the toll series via SMS, in case of orders registered on the website). On www.e-rovinieta.ro, the online payment processor with the bank card (in the case of online payments with the bank card). The personal data required to make online card payments will be securely transferred to the payment processor.</span>
						</p>
						<p>
							<span>
								<strong>Pursuant to REGULATION (EU) 2016/679 OF THE EUROPEAN PARLIAMENT AND OF THE COUNCIL of 27 April 2016</strong>
							</span>
							<span> on the protection of individuals with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation):</span>
						</p>
						<p>
							<span>
								<strong>Art. 13: Information to be provided if personal data is collected from the data subject </strong>
							</span>
						</p>
						<p>
							<span>(1) If personal data concerning a data subject is collected from that data subject, the controller shall, when obtaining such personal data, provide the data subject with all the following information:</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) the identity and contact details of the operator and, as the case may be, of his representative;</span>
								</p>
							</li>
							<li>
								<p>
									<span>b) the contact details of the data protection officer, as the case may be;</span>
								</p>
							</li>
							<li>
								<p>
									<span>c) the purposes for which the personal data are processed, as well as the legal basis of the processing;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(d) where the processing is carried out pursuant to Article 6 (1) (f), the legitimate interests pursued by the controller or a third party;</span>
								</p>
							</li>
							<li>
								<p>
									<span>e) the recipients or categories of recipients of personal data;</span>
								</p>
							</li>
							<li>
								<p>
									<span>f) where applicable, the intention of the controller to transfer personal data to a third country or international organization and the existence or absence of a Commission decision on the appropriateness or, in the case of transfers referred to in Article 46 or 47 or Article 49 (1), second subparagraph, a reference to the appropriate or appropriate guarantees and the means of obtaining a copy if they have been made available.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>(2) In addition to the information referred to in paragraph 1, when the personal data are obtained, the controller shall provide the data subject with the following additional information necessary to ensure fair and transparent processing:</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) the period for which the personal data will be stored or, if this is not possible, the criteria used to establish this period;</span>
								</p>
							</li>
							<li>
								<p>
									<span>b) the existence of the right to request from the controller, as regards personal data concerning the data subject, access to them, rectification or deletion thereof or restriction of processing or the right to oppose processing, as well as the right to portability data;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(c) where the processing is based on Article 6 (1) (a) or Article 9 (2) (a), the existence of the right to withdraw consent at any time, without prejudice to the lawfulness of the processing carried out on the basis of consent before its withdrawal;</span>
								</p>
							</li>
							<li>
								<p>
									<span>d) the right to lodge a complaint with a supervisory authority;</span>
								</p>
							</li>
							<li>
								<p>
									<span>e) whether the provision of personal data is a legal or contractual obligation or an obligation necessary to conclude a contract, as well as whether the data subject is obliged to provide such personal data and what are the possible consequences of non-compliance with this obligation;</span>
								</p>
							</li>
							<li>
								<p>
									<span>f) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>(3) If the controller intends to further process personal data for a purpose other than that for which they were collected, the controller shall provide the data subject, before such further processing, with information on that secondary purpose and any relevant additional information, in accordance with paragraph (2).</span>
						</p>
						<p>
							<span>(4) Paragraphs (1), (2) and (3) shall not apply if and in so far as the data subject already holds that information.</span>
						</p>
						<table class="table my-4">
							<tbody>
								<tr>
									<td width="104">
										<p>
											<strong>Personal data</strong>
										</p>
									</td>
									<td width="447">
										<p>
											<strong>Reason</strong>
										</p>
									</td>
									<td width="73">
										<p>
											<strong>Storage period according to legal provisions</strong>
										</p>
									</td>
								</tr>
								<tr>
									<td width="104">
										<p>Surname and name</p>
									</td>
									<td width="447">
										<p>Issuance of invoice</p>
									</td>
									<td width="73">
										<p>10 years</p>
									</td>
								</tr>
								<tr>
									<td width="104">
										<p>Address</p>
									</td>
									<td width="447">
										<p>Issuance of invoice according to the tax code art. 319 paragraph 20</p>
									</td>
									<td width="73">
										<p>10 years</p>
									</td>
								</tr>
								<tr>
									<td width="104">
										<p>Telephone</p>
									</td>
									<td width="447">
										<p>Vignette issue notification (optional)</p>
										<p>Contact if the data is wrong or the order failed</p>
									</td>
									<td width="73">
										<p>3 years</p>
									</td>
								</tr>
								<tr>
									<td width="104">
										<p>Email</p>
									</td>
									<td width="447">
										<p>Confirm account creation</p>
										<p>Send the vignette invoice</p>
										<p>Account deletion notification</p>
									</td>
									<td width="73">
										<p>3 years</p>
									</td>
								</tr>
								<tr>
									<td width="104">
										<p>Vehicle data</p>
									</td>
									<td width="447">
										<p>Vignette issuance</p>
									</td>
									<td width="73">
										<p>10 years</p>
									</td>
								</tr>
								<tr>
									<td width="104">
										<p>IP Address</p>
									</td>
									<td width="447">
										<p>Web application logs (this information is required in case of a DDoS attack) or anonymous traffic analysis</p>
									</td>
									<td width="73">
										<p>30 days</p>
									</td>
								</tr>
							</tbody>
						</table>
						<p>
							<span>
								<strong>Art. 14: Information to be provided if personal data was not obtained from the data subject </strong>
							</span>
						</p>
						<p>
							<span>(1) If personal data have not been obtained from the data subject, the controller shall provide the data subject with the following information.:</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) the identity and contact details of the operator and, as the case may be, of his representative;</span>
								</p>
							</li>
							<li>
								<p>
									<span>b) the contact details of the data protection officer, as the case may be;</span>
								</p>
							</li>
							<li>
								<p>
									<span>c) the purposes for which the personal data are processed, as well as the legal basis of the processing;</span>
								</p>
							</li>
							<li>
								<p>
									<span>d) the categories of personal data concerned;</span>
								</p>
							</li>
							<li>
								<p>
									<span>e) the recipients or categories of recipients of personal data, as the case may be;</span>
								</p>
							</li>
							<li>
								<p>
									<span>f) where applicable, the intention of the controller to transfer personal data to a recipient in a third country or an international organization and the existence or absence of a Commission decision on the appropriateness or, in the case of transfers referred to in Article 46, or 47 or in the second subparagraph of Article 49 (1), a reference to the appropriate or appropriate guarantees and to the means of obtaining a copy thereof, if they have been made available.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>(2) In addition to the information referred to in paragraph 1, the controller shall provide the data subject with the following information necessary to ensure fair and transparent processing in respect of the data subject:</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) the period for which the personal data will be stored or, if this is not possible, the criteria used to establish this period;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(b) where the processing is carried out pursuant to Article 6 (1) (f), the legitimate interests pursued by the controller or a third party;</span>
								</p>
							</li>
							<li>
								<p>
									<span>c) the existence of the right to request from the controller, as regards personal data concerning the data subject, access to them, their rectification or deletion or restriction of processing and the right to oppose processing, as well as the right to portability data;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(d) where the processing is based on Article 6 (1) (a) or Article 9 (2) (a), the existence of the right to withdraw consent at any time, without prejudice to the lawfulness of the processing carried out on the basis of consent before its withdrawal;</span>
								</p>
							</li>
							<li>
								<p>
									<span>e) the right to lodge a complaint with a supervisory authority;</span>
								</p>
							</li>
							<li>
								<p>
									<span>f) the source from which the personal data come and, if applicable, if they come from publicly available sources;</span>
								</p>
							</li>
							<li>
								<p>
									<span>g) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>(3) The operator shall provide the information referred to in paragraphs (1) and (2):</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) within a reasonable time after obtaining the personal data, but not more than one month, taking into account the specific circumstances in which the personal data are processed;</span>
								</p>
							</li>
							<li>
								<p>
									<span>b) if the personal data are to be used for communication with the data subject, at the latest at the time of the first communication to the data subject concerned; or</span>
								</p>
							</li>
							<li>
								<p>
									<span>c) if it is intended to disclose personal data to another recipient, at the latest on the date on which they are first disclosed.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>(4) If the controller intends to further process personal data for a purpose other than that for which they were obtained, the controller shall provide the data subject, before such further processing, with information on that secondary purpose and any relevant additional information, in in accordance with paragraph (2).</span>
						</p>
						<p>(5) Paragraphs (1)-(4) do not apply if and to the extent that:</p>
						<ol>
							<li>
								<p>
									<span>a) the data subject already has the information;</span>
								</p>
							</li>
							<li>
								<p>
									<span>b) the provision of this information proves to be impossible or would involve disproportionate efforts, especially in the case of processing for archiving purposes in the public interest, for scientific or historical research purposes or for statistical purposes, subject to the conditions and guarantees provided in Article 89 (1), or in so far as the obligation referred to in paragraph 1 of this Article is likely to make it impossible or would seriously affect the achievement of the objectives of such processing, the operator shall take appropriate measures to protect the rights, freedoms and legitimate interests of the data subject, including making the information available to the public;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(c) the obtaining or disclosure of data is expressly provided for by Union or national law to which the controller is subject and which provides for appropriate measures to protect the legitimate interests of the data subject; or</span>
								</p>
							</li>
							<li>
								<p>
									<span>d) where personal data must remain confidential under a statutory obligation of professional secrecy governed by Union or national law, including a legal obligation to maintain secrecy.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>
								<strong>Art. 15: The right of access of the data subject </strong>
							</span>
						</p>
						<p>
							<span>(1) The data subject has the right to obtain from the controller a confirmation that personal data concerning him or her are being processed or not and, if so, access to those data and to the following information:</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) processing purposes;</span>
								</p>
							</li>
							<li>
								<p>
									<span>b) the categories of personal data concerned;</span>
								</p>
							</li>
							<li>
								<p>
									<span>c) the recipients or categories of recipients to whom personal data have been or are to be disclosed, in particular recipients from third countries or international organizations;</span>
								</p>
							</li>
							<li>
								<p>
									<span>d) where possible, the period for which personal data are expected to be stored or, if this is not possible, the criteria used to establish this period;</span>
								</p>
							</li>
							<li>
								<p>
									<span>e) the existence of the right to request the operator to rectify or delete personal data or to restrict the processing of personal data relating to the data subject or the right to oppose the processing;</span>
								</p>
							</li>
							<li>
								<p>
									<span>f) the right to lodge a complaint with a supervisory authority;</span>
								</p>
							</li>
							<li>
								<p>
									<span>g) if personal data are not collected from the data subject, any available information on their source;</span>
								</p>
							</li>
							<li>
								<p>
									<span>h) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>(2) Where personal data are transferred to a third country or an international organization, the data subject shall have the right to be informed of the appropriate safeguards under Article 46 concerning the transfer.</span>
						</p>
						<p>
							<span>(3) The operator shall provide a copy of the personal data subject to processing. For any other copies requested by the data subject, the operator may charge a reasonable fee, based on administrative costs. Where the data subject submits the application in electronic format and unless the data subject requests another format, the information shall be provided in a commonly used electronic format.</span>
						</p>
						<p>
							<span>(4) The right to obtain a copy referred to in paragraph 3 shall be without prejudice to the rights and freedoms of others.</span>
						</p>
						<p>
							<span>
								<strong>Amendment and deletion</strong>
							</span>
						</p>
						<p>
							<span>
								<strong>Art. 16: The right to amend </strong>
							</span>
						</p>
						<p>
							<span>The data subject has the right to obtain from the controller, without undue delay, the rectification of inaccurate personal data concerning him. Taking into account the purposes for which the data were processed, the data subject has the right to obtain the completion of personal data that are incomplete, including by providing an additional statement.</span>
						</p>
						<p>
							<span>
								<strong>Art. 17: The right to delete data ("the right to be forgotten") </strong>
							</span>
						</p>
						<p>
							<span>(1) The data subject has the right to obtain from the controller the deletion of personal data concerning him, without undue delay, and the controller has the obligation to delete personal data without undue delay if one of the following reasons applies:</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) personal data are no longer necessary for the purposes for which they were collected or processed;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(b) the data subject withdraws his or her consent on the basis of which the processing takes place in accordance with Article 6 (1) (a) or Article 9 (2) (a), and there is no other legal basis for processing;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(c) the data subject opposes the processing pursuant to Article 21 (1) and there are no legitimate reasons prevailing in respect of the processing or the data subject opposes the processing pursuant to Article 21 (2);</span>
								</p>
							</li>
							<li>
								<p>
									<span>d) personal data have been illegally processed;</span>
								</p>
							</li>
							<li>
								<p>
									<span>e) personal data must be deleted in order to comply with a legal obligation incumbent on the controller under Union or national law to which the controller is subject;</span>
								</p>
							</li>
							<li>
								<p>
									<span>f) personal data have been collected in connection with the provision of information society services referred to in Article 8 paragraph (1).</span>
								</p>
							</li>
						</ol>
						<p>
							<span>The account will be deleted in maximum 30 days from the request received from the client.</span>
						</p>
						<p>
							<span>2. If the controller has made his personal data public and is obliged to delete them pursuant to paragraph (1), the controller shall, taking into account the available technology and the cost of implementation, take reasonable measures, including technical measures, to inform operators who process personal data that the data subject has requested the deletion by these operators of any links to those data or of any copies or reproductions of such personal data.</span>
						</p>
						<p>
							<span>3. Paragraphs 1 and 2a shall not apply in so far as processing is necessary:</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) for the exercise of the right to free expression and information;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(b) for compliance with a legal obligation which provides for processing under Union or national law applicable to the controller or for the performance of a task performed in the public interest or in the exercise of official authority with which the controller is vested;</span>
								</p>
							</li>
							<li>
								<p>
									<span>(c) for reasons of public interest in the field of public health, in accordance with Article 9 (2) (h) and (i) and Article 9 (1) (3);</span>
								</p>
							</li>
							<li>
								<p>
									<span>d) for archiving purposes in the public interest, for scientific or historical research or for statistical purposes, in accordance with Article 89 (1), in so far as the right referred to in paragraph 1 is likely to make it impossible or seriously achieving the objectives of that processing; or</span>
								</p>
							</li>
							<li>
								<p>
									<span>e) for ascertaining, exercising or defending a right in court.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>
								<strong>Art. 18: The right to restrict processing </strong>
							</span>
						</p>
						<p>
							<span>(1) The data subject has the right to obtain from the operator the restriction of processing if one of the following cases applies:</span>
						</p>
						<ol>
							<li>
								<p>
									<span>a) the data subject disputes the accuracy of the data, for a period which allows the controller to verify the accuracy of the data;</span>
								</p>
							</li>
							<li>
								<p>
									<span>b) the processing is illegal, and the data subject opposes the deletion of personal data, requesting in return the restriction of their use;</span>
								</p>
							</li>
							<li>
								<p>
									<span>c) the controller no longer needs personal data for the purpose of processing, but the data subject requests them for the establishment, exercise or defence of a right in court; or</span>
								</p>
							</li>
							<li>
								<p>
									<span>(d) the data subject has objected to the processing in accordance with Article 21 (1), for the period during which it is verified whether the legitimate rights of the controller prevail over those of the data subject.</span>
								</p>
							</li>
						</ol>
						<p>
							<span>(2) Where processing has been restricted pursuant to paragraph 1, such personal data may, except in the case of storage, be processed only with the consent of the data subject or for the establishment, exercise or defence of a right in court or for the protection of rights. Another individual or legal entity or for reasons of important public interest of the Union or of a Member State.</span>
						</p>
						<p>
							<span>3. A data subject who has obtained a processing restriction pursuant to paragraph 1 shall be informed by the controller before the processing restriction is lifted.</span>
						</p>
						<p>
							<span>To exercise these rights, you can address a written request, dated and signed at the UNTRR registry in Bucharest, str. Ienachita Vacarescu no. 60, 4</span>
							<sup>
								<span>th</span>
							</sup>
							<span> district, zip code 040157 or by phone at 0720999216 or by email at protectiadatelor@untrr.ro. You also have the right to go to court.</span>
						</p>
					</div>
				</template>
			</div>
        </div>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'
import { mapState } from 'vuex'

export default {
    name: 'Confidentiality',
    components: {
        Heading
    },
    props: {
        inModal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('language', [
            'locale'
        ])
    }
}

</script>

<style lang="css" scoped>

</style>
